import { NgModule } from '@angular/core';
import { EntityDataLayoutComponent } from "./entity-data-layout.component";
import { EntityDataLayoutService } from "./entity-data-layout.service";
import {OriginalLayoutModule} from "@layout/layouts/original/original-layout.module";
import {SharedModule} from "@shared/shared.module";
import {DesktopAlertModule} from "@feature/_app_modules/desktop-alert/desktop-alert.module";
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';

@NgModule({
  declarations: [
    EntityDataLayoutComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    DialogModule,
    DesktopAlertModule,
    OriginalLayoutModule,
  ],
  exports: [
    EntityDataLayoutComponent,
  ],
  providers: [
    EntityDataLayoutService
  ]
})
export class EntityDataLayoutModule { }
